import React, { useEffect } from 'react';
import ReactModal from 'react-modal';

export const TimeoutErrorModal = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);

  return (
    <ReactModal
      isOpen={true}
      className="dialog error"
      overlayClassName="overlay contentCenter disabled"
    >
      <div className="modalContainer">
        <div className="modalContent">
          <div className="modalHeader error">
            <div className="modalTitle">エラー</div>
          </div>
          <div className="modalBody error">
            <div className="errorMessage">
              アクセスが集中して繋がりにくくなっております。<br/>
              しばらくして再度アクセスいただけますようお願い申し上げます。
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default TimeoutErrorModal;
